import { render, staticRenderFns } from "./SampleBatchStatus.vue?vue&type=template&id=97bbf728&scoped=true"
import script from "./SampleBatchStatus.vue?vue&type=script&lang=ts"
export * from "./SampleBatchStatus.vue?vue&type=script&lang=ts"
import style0 from "./SampleBatchStatus.vue?vue&type=style&index=0&id=97bbf728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bbf728",
  null
  
)

export default component.exports